import { Laptop, Cloud, Wifi, Phone, Cctv, Tv } from "lucide-react";
import SLUGS from "./serviceSlugs.json";
import LEGACY from "./legacySlugs.json";

export const BRAND_NAME = "JMS Technologies";
export const LEGAL_NAME = "James Matthews Solutions";
export const TAGLINE = "Modern Solutions. Simplified.";
export const DESCRIPTOR = "Modern Business Solutions";

export const PHONE_DISPLAY = "226-626-3220";
export const PHONE_HREF = "tel:+12266263220";
export const SITE_URL = (process.env.REACT_APP_SITE_URL || process.env.REACT_APP_BACKEND_URL).replace(/\/$/, "");
export const AREA_CITIES = ["Chatham-Kent", "Chatham", "Blenheim", "Wallaceburg", "Ridgetown", "Tilbury", "Dresden", "Wheatley"];
export const LEGACY_SLUGS = LEGACY;

// PLACEHOLDER PHOTOS: AI-generated stand-ins until the owner supplies approved photography.
const IMG = "https://static.prod-images.emergentagent.com/jobs/cec964bb-7df5-4a93-ac40-a12deea7c349/images";

export const HERO_IMAGE = `${IMG}/5470e308e546290fd4f67e6efc9761429d4c473ab9e481a8f5394f5394f5c0b3.jpeg`;

export const NAV_LINKS = [
  { label: "Home", href: "#home" },
  { label: "Services", href: "#services" },
  { label: "Industries", href: "#industries" },
  { label: "About", href: "#about" },
  { label: "Contact", href: "#contact" },
  { label: "Support", href: "#support" },
];

export const SERVICES = [
  {
    id: "it",
    slug: SLUGS.it,
    label: "IT",
    title: "Business IT & Computers",
    desc: "Workstations, upgrades, troubleshooting and ongoing support.",
    icon: Laptop,
    image: `${IMG}/f47ecf50204e2ca5fafe4f6d0c840560b7d8f7cd5bee5a9d16704fad0e6c5b1e.jpeg`,
  },
  {
    id: "m365",
    slug: SLUGS.m365,
    label: "M365",
    title: "Microsoft 365 & Cloud",
    desc: "Email, Teams, OneDrive, SharePoint, administration and migrations.",
    icon: Cloud,
    image: `${IMG}/246a3e777b9f629d3a11ebe56e037a37aa888a0d62b0c86e3ec22ca6cb9cb4e6.jpeg`,
  },
  {
    id: "networking",
    slug: SLUGS.networking,
    label: "Networks",
    title: "Networking & Wi-Fi",
    desc: "Secure business wireless, routing, switching and infrastructure.",
    icon: Wifi,
    image: `${IMG}/6c209c48098e357b272cd00e2d30c51fe72ecac936faaa6b1cdb0c132a2fb20b.jpeg`,
  },
  {
    id: "phones",
    slug: SLUGS.phones,
    label: "Phones",
    title: "Business Phones & VoIP",
    desc: "Modern office phone systems, handsets and communications.",
    icon: Phone,
    image: `${IMG}/ab7f7674d51b1ddc2d166765ccbab8538d4e7329840cd4b6b276b3a658e10b15.jpeg`,
  },
  {
    id: "security",
    slug: SLUGS.security,
    label: "Cameras",
    title: "Security Cameras & Surveillance",
    desc: "Commercial camera system design, installation and support.",
    icon: Cctv,
    image: `${IMG}/56b178c9feafdd301b634fcb6b3d0b907575d4fae3233710b918293b5b7d0369.jpeg`,
  },
  {
    id: "displays",
    slug: SLUGS.displays,
    label: "Ad TVs",
    title: "Advertisement TVs",
    desc: "Eye-catching advertising screens, promo displays and digital menus that help your business get noticed.",
    icon: Tv,
    image: `${IMG}/2a927e887019bf9e2bf094b5b22147605e3bd2533569e9fd41508442e7a26c89.jpeg`,
  },
];

export const OTHER_SERVICE = "Not sure / Other";
export const SUPPORT_REQUEST = "Support request (existing client)";
